<div class="d-flex align-items-baseline mr-2">
  <div class="dropdown-menu-wrapper btn btn-secondary btn-link" ngbDropdown placement="bottom-right">
    <span id="dynamic-list-dropdown-menu" ngbDropdownToggle>
      <i class="now-ui-icons design_bullet-list-67"></i>
    </span>
    <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="dynamic-list-dropdown-menu">
      @for (menuItem of menuItems; track menuItem) {
        <a class="dropdown-item" (click)="itemClick(menuItem)">{{ menuItem.label |
        translate }}</a>
      }
    </div>
  </div>
</div>